import {
  Component,
  Injectable,
  OnInit,
  ViewChild,
  TemplateRef,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  HostListener,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import * as _ from 'lodash';
import { ChatService } from '../../../../common/services/Chat.service';
import { SocketService } from '../../../../common/services/Socket.service';
import { EvsUserService } from '../../../../common/services/EvsUser.service';
import { TicketService } from '../../../../common/services/Ticket.service';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ContactService } from '../../../../common/services/Contact.service';
import { RoomService } from '../../../../common/services/Room.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { UserService } from '../../../../common/services/User.service';
import { SearchService } from '../../../../common/services/Search.service';
import { environment } from 'environments/environment';
import { GroupService } from '../../../../common/services/Group.service';
import { DownloadService } from '../../../../common/services/Download.service';
import { TemplateService } from '../../../../common/services/Template.service';
import { CommonService } from 'app/common/services/Common.service';

declare var $: any;

@Component({
  selector: 'chats-internal',
  templateUrl: './chat_internal.template.html',
  styleUrls: ['../../../../../css/fuck.css', './chat.css'],
  providers: [
    BsModalService,
    ContactService,
    GroupService,
    UserService,
    SearchService,
    TemplateService,
    DownloadService,
    CommonService,
  ],
})
@Injectable()
export class ChatInternalComponent implements OnInit {
  @ViewChild('lgModal') lgModal: ModalDirective;
  @Output('backTab') backTab = new EventEmitter();
  modalRef: BsModalRef;

  public list: any = [];
  public list_devide_page: any = [];
  public list_agent_devide_page: any = [];
  isSorting: any = {};
  user: any = [];
  image_agent = 'assets/images/agent.jpg';
  image_contact = 'assets/images/contact.png';
  no_image = 'assets/images/contact.png';
  public messages: any = [];
  ioConnection: any;
  ioConnection1: any;
  public message: any;
  @Input()
  public room_id: any;
  public allAccount: any = [];

  public currentPage = 1;
  public page_size = 10;
  public history: any = [];
  public alerts: any = {};
  public msg_list: any = {};
  public agent_onlines: any = [];
  public invite_msg = '';
  public msg_obj: any = {};
  public agents_in_room: any = [];
  public agents_id_in_room: any = [];
  public list_no_received: any = [];
  public can_leave = false;
  public can_forward = false;
  public onlines: any = {};
  public agents_status: any = {};
  public tab = 'internal';
  public sender: any = {};
  public room: any = null;
  public model: any = {};
  public mode_edit = false;

  public inputTicket: any = null;
  public btnHistory = true;

  public modelFilter: any = {};
  public listAgent: any = [];
  public allGroup: any = [];
  public totalItem = 0;
  public totalPage = 0;
  public currentPage_agent = 1;

  public modelSearch: any = {};
  public userList: any = [];
  public is_searching = false;
  public showAutoComplete = true;
  public templates: any = [];
  public allTemplate: any = [{ id: '', text: '' }];
  public chatTemplate: any;
  public limit = 15;
  public totalList = 0;
  public totalAgent = 0;
  public isLoad = false;
  public keyword = '';
  public agents_to_chat: any = [];

  @ViewChild('confirm_invite') confirmInvite: ElementRef;
  @ViewChild('confirm_forward') confirmForward: ElementRef;

  constructor(
    private userService: UserService,
    private chatService: ChatService,
    private ticketService: TicketService,
    private socketService: SocketService,
    private toastr: ToastrService,
    private groupService: GroupService,
    private uploadService: UploadService,
    private modalService: BsModalService,
    private searchService: SearchService,
    private templateService: TemplateService,
    private downloadService: DownloadService,
    private commonServer: CommonService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.initIoConnection();
  }

  ngOnInit() {
    this.loadData();
    this.getTemplate();
  }

  getAgentOnline() {
    this.agent_onlines = [];
    this.chatService.agentOnlines({}).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        _.map(res.data, e => {
          if (this.room) {
            const check = _.find(this.room.agents, { id: e._id });
            if (!check) {
              this.agent_onlines.push(e);
            }
          } else {
            this.agent_onlines.push(e);
          }
        });
      }
    });
  }

  loadData() {
    const request = {};
    request['limit'] = this.limit;
    request['keyword'] = this.keyword;
    this.chatService
      .listInternal(request)
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.isLoad = false;
          if (!res.data.data) {
            return;
          }
          this.list = res.data.data;
          this.agents_to_chat = res.data.agents;
          this.totalList = res.data.total;
          this.totalAgent = res.data.totalAgent;
          this.list.forEach(e => {
            this.alerts[e._id] = e ? e.unread : 0;
            this.msg_list[e._id] = e ? e.last_msg : '';
            this.onlines[e._id] =
              e.type == 'private' && e.agents[0] && e.agents[0].is_online ? e.agents[0].is_online : 0;
          });
          if (this.list.length > 0 && !this.room_id) {
            this.viewChat(this.list[0]._id, this.list[0]);
          }
          this.list_devide_page = this.list.slice(0, this.limit); // Khi tìm kiếm keyword sẽ gán limit =9999 ở phía server nên this.list có thể rất lớn

          this.list_agent_devide_page = this.agents_to_chat.slice(0, this.limit); // hiển thị khi k tìm thấy agent nào đang trong cuộc hội thoại
        }
      });
  }

  getTemplate(request: any = {}, sort: any = {}) {
    this.templateService.chatTemplate().subscribe(res => {
      this.templates = res.data;
      const templateList = [];
      res.data.forEach((c: any) => {
        templateList.push({
          id: c.id,
          text: c.template_name,
        });
      });
      this.allTemplate = templateList;
    });
  }
  useTemplate(id) {
    const template = this.templates.find(x => x.id == id);
    if (template) {
      this.message = template.template_content;
    }
    if (template.attach_file) {
      this.chatTemplate = {
        chatter_id: this.user._id,
        chatter_name: this.user.name,
        chatter_type: 'agent',
        content: template.attach_file,
        type: 'file', // image , file
        avatar: this.user.avatar ? this.user.avatar : '',
        date: Date.now(),
      };
    }
  }

  searchUser($event) {
    this.userList = [];
    const keyword = this.modelSearch.keyword;

    if (keyword.length >= 2) {
      this.is_searching = true;
      this.searchService
        .user({
          keyword: keyword,
          role: JSON.stringify(['agent', 'administrator']),
        })
        .subscribe(
          res => {
            if (res.status == 200 && res.error == false) {
              this.userList = res.data;
            } else {
              this.userList = [];
            }
            this.is_searching = false;
          },
          error => {
            this.showAutoComplete = false;
          }
        );
    }
  }

  chatWithFriend(user) {
    let flag = 0;
    let room_id_flag = null;
    let room_flag = {};
    this.list.forEach(e => {
      if (e.agents.length == 1) {
        if (e.agents[0]._id == user._id) {
          flag = 1;
          room_id_flag = e._id;
          room_flag = e;
        }
      }
    });
    if (flag == 1) {
      this.viewChat(room_id_flag, room_flag);
      this.showAutoComplete = false;
    } else {
      this.chatService.internalChat(user._id).subscribe(res => {
        if (res.status == 200 && res.error == false) {
          this.room_id = res.data._id;
          this.chatService.joinInternal(res.data._id, this.user._id);
          this.loadData();
          this.viewChat(this.room_id, res.data);
        }
      });
      this.showAutoComplete = false;
    }
  }

  showHistory(page) {
    this.currentPage = page;
    const request = {
      // offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
      // limit: this.page_size
    };
    this.chatService.historyInternal(this.room_id, request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        if (res.data.history.length == 0) {
          this.btnHistory = false;
        }
        this.history = _.concat(res.data.history, this.history);
        setTimeout(() => {
          const mailContent = document.getElementById('mailContent');
          mailContent.scrollTop = mailContent.scrollHeight;
        }, 500);
        // this.history = res.data.history;
      }
    });
  }

  getAccounts() {
    this.userService.list().subscribe(res => {
      this.allAccount = res.data.staffs;
    });
  }

  changeTab(tab) {
    this.keyword = '';
    this.backTab.emit(tab);
  }

  viewChat(room_id, room?: any) {
    this.mode_edit = false;
    this.currentPage = 1;
    this.messages = [];
    const request = {
      // offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
      // limit: this.page_size
    };

    this.room = room;
    this.chatService.historyInternal(room_id, request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.history = res.data.history;
        if (this.history.length == 0) {
          this.btnHistory = false;
        }
        setTimeout(() => {
          const mailContent = document.getElementById('mailContent');
          mailContent.scrollTop = mailContent.scrollHeight;
        }, 500);
      }
    });

    this.can_leave = false;
    if (room.type == 'public') {
      this.can_leave = true;
    }

    if (room.type == 'private' && room.agents[0]._id) {
      this.sender = room.agents[0];
      // this.userService.find(room.agents[0]._id).subscribe(res => {
      //     this.sender = {
      //         name : res.data.name,
      //         phone : res.data.phone,
      //         email : res.data.email,
      //         avatar : res.data.avatar,
      //         room: res.data.room_name ?res.data.room_name : null,
      //         type: 'Chuyên viên'
      //     }
      // })
    }
    this.agents_id_in_room = [];
    this.agents_in_room = room.agents;
    this.agents_in_room.forEach(e => this.agents_id_in_room.push(e._id));
    // join
    if (this.room_id) {
      this.chatService.leave(this.room_id);
    }
    this.room_id = room_id;
    this.chatService.joinInternal(this.room_id, this.user._id);

    this.socketService.updateChatNotify(this.alerts[room_id]); // reset alert
    this.alerts[this.room_id] = 0;

    this.chatService.resetUnreadInternal(this.room_id).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.alerts[this.room_id] = 0;
      }
    });
  }

  openUser(user) {
    this.socketService.opentab(user, 'user', 'edit');
  }

  download_file(fileUrl) {
    const fileName = this.get_name_file(fileUrl);
    this.downloadService.downloadFile(fileUrl, fileName);
  }

  get_name_file(file) {
    const arr = file.split('/');
    const fileName = arr.pop();
    return fileName;
  }

  isImage(file) {
    let check = false;
    const extension = file.substr(file.lastIndexOf('.') + 1);
    switch (extension) {
      case 'jpg':
      case 'png':
      case 'gif':
      case 'jpeg':
        check = true;
        break; // the alert ended with pdf instead of gif.
      default:
        break;
    }
    return check;
  }

  url_file(file) {
    if (file.indexOf('http') != -1) {
      return file;
    } else {
      return environment.api_evs + '/' + file;
    }
  }

  openConfirmLeave(template: TemplateRef<any>) {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  leaveRoom() {
    this.chatService.leaveRoomInternal(this.room_id).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.chatService.sendInternal(this.room_id, {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: '',
          type: 'action-leave',
          avatar: '',
          date: Date.now(),
        });
        this.room_id = null;
        this.loadData();
      }
    });
  }

  inviteChat(agent_id, agent_name) {
    this.chatService.inviteFriendInternal(this.room_id, agent_id).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.chatService.sendInternal(this.room_id, {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: '',
          friend_name: agent_name,
          type: 'action-invite',
          avatar: '',
          date: Date.now(),
        });
        // this.listAgent.forEach(e => {
        //   if(e._id == agent_id) {
        //     this.room.agents.push(e);
        // }
        // })
        this.loadData();
        // this.viewChat(this.room_id, this.room);
      }
    });
  }

  chatting() {
    if (this.message && this.message.trim() != '') {
      const _msg = {
        chatter_id: this.user._id,
        chatter_name: this.user.name,
        chatter_type: 'agent',
        content: this.message,
        type: 'text', // image , file
        avatar: this.user.avatar ? this.user.avatar : '',
        date: Date.now(),
      };
      this.messages.push(_msg);
      this.message = '';
      this.chatService.sendInternal(this.room_id, _msg);
    }
    if (this.chatTemplate) {
      this.chatService.sendInternal(this.room_id, this.chatTemplate);
      this.messages.push(this.chatTemplate);
      this.chatTemplate = null;
    }
    setTimeout(() => {
      const mailContent = document.getElementById('mailContent');
      mailContent.scrollTop = mailContent.scrollHeight;
      this.message = '';
    }, 200);
  }

  _keydownName(event: any) {
    if (this.model.name && this.model.name.trim() != '') {
      this.chatService.editRoomName(this.room_id, { name: this.model.name }).subscribe(res => {
        if (res.status == 200 && res.error == false) {
          this.room.name = this.model.name;
        }
        this.mode_edit = false;
      });
    } else {
      this.mode_edit = false;
    }
  }

  _keydown(event: any) {
    if (event.keyCode == 13) {
      if (this.message && this.message.trim() != '') {
        const _msg = {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: this.message,
          type: 'text', // image , file
          avatar: this.user.avatar ? this.user.avatar : '',
          date: Date.now(),
        };
        this.messages.push(_msg);

        this.msg_list[this.room_id] = _msg.content;
        this.chatService.sendInternal(this.room_id, _msg);
        setTimeout(() => {
          const mailContent = document.getElementById('mailContent');
          mailContent.scrollTop = mailContent.scrollHeight;
          this.message = '';
          if (this.list[0]._id != this.room_id) {
            this.list.unshift(this.list.splice(this.list.findIndex(e => e._id == this.room_id))[0]);
          }
        }, 200);
      }
    }
  }

  chatInternal(friend_id) {
    if (friend_id != this.user._id) {
      this.chatService.internalChat(friend_id).subscribe(res => {
        this.tab = 'internal';
        if (res.status == 200 && res.error == false) {
          this.room_id = res.data._id;
          this.chatService.joinInternal(res.data._id, this.user._id);
        }
      });
    }
  }

  getGroups() {
    this.groupService.allGroup({ target: 'user' }).subscribe(res => {
      const groupList = [];
      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allGroup = groupList;
    });
  }

  getStaffs(request: any = {}, sort: any = {}) {
    this.listAgent = [];
    request.offset = this.page_size * (this.currentPage_agent <= 0 ? 0 : this.currentPage_agent - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.userService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.listAgent = res.data.list;
        this.totalItem = res.data.total;
        const pageString = (this.totalItem / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      } else {
        this.listAgent = [];
      }
    });
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage_agent) {
        this.currentPage_agent = page;
        this.getStaffs();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage_agent) {
          this.currentPage_agent = page;
          this.getStaffs();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  filterAgent() {
    this.currentPage_agent = 1;
    const options = [];
    if (this.modelFilter.filter_agent_phone && this.modelFilter.filter_agent_phone.trim() != '') {
      options.push({
        key: 'phone',
        condition: '=',
        value: this.modelFilter.filter_agent_phone,
      });
    }
    if (this.modelFilter.group_id) {
      options.push({
        key: 'group_id',
        condition: '=',
        value: this.modelFilter.group_id,
      });
    }
    this.getStaffs({ filters: JSON.stringify(options) });
  }

  public changedFilterGroup(e: any): void {
    this.modelFilter.group_id = e.value;
  }

  uploadFile(type) {
    if (type == 'file') {
      $('#messageFile').trigger('click');
    } else if (type == 'image') {
      $('#messageImage').trigger('click');
    }
  }

  sendFile($event, type) {
    const files = $event.srcElement.files;
    const file = files[0];
    if (file.size > 2 * 1024 * 1024) {
      this.toastr.error('Dung lượng file tối đa 2Mb', 'Lỗi', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (/.*\.(png|jpg|jpeg)$/.test(file.name.toLowerCase()) == false && type == 'image') {
      this.toastr.error('Định dạng file gửi không đúng (png, jpg, jpeg)', 'Lỗi', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (/.*\.(docx|doc|xlsx|xls|pdf)$/.test(file.name.toLowerCase()) == false && type == 'file') {
      this.toastr.error('Định dạng file gửi không đúng (docx, doc, xlsx, xls, pdf)', 'Lỗi', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    this.uploadService.upload(files[0]).then((res: any) => {
      if (!res.error) {
        const data = {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: this.commonServer.file(res.data),
          type: 'file', // image , file
          avatar: this.user.avatar ? this.user.avatar : '',
          date: Date.now(),
        };
        this.chatService.sendInternal(this.room_id, data);
        this.messages.push(data);
        setTimeout(() => {
          const mailContent = document.getElementById('mailContent');
          mailContent.scrollTop = mailContent.scrollHeight;
        }, 200);
        $event.target.value = null;
      } else {
        this.toastr.error(res.data.message, 'Lỗi', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  private initIoConnection(): void {
    this.ioConnection = this.chatService.onMessageInternal().subscribe((message: any) => {
      const room_id = message.room_id;
      if (message.type == 'action-leave' || message.type == 'action-invite') {
        this.loadData();
      }
      if (this.room_id == room_id) {
        this.messages.push(message);
      }
      setTimeout(() => {
        const mailContent = document.getElementById('mailContent');
        mailContent.scrollTop = mailContent.scrollHeight;
        if (this.list[0]._id != message.room_id) {
          this.list.unshift(this.list.splice(this.list.findIndex(e => e._id == message.room_id))[0]);
        }
      }, 200);
    });

    this.chatService.onUpdateChattingInternal().subscribe((message: any) => {
      const check = _.find(message.agents, { agent_id: this.user._id });
      if (check) {
        this.alerts[message.room_id] = check.unread;
        this.msg_list[message.room_id] = message.content;
      }
    });

    this.chatService.onEvent('connect').subscribe(() => {
      console.log('connected');
    });

    this.chatService.onEvent('disconnect').subscribe(() => {
      console.log('disconnected');
    });
  }

  @HostListener('scroll', ['$event'])
  onLazyload(event: any) {
    const totalScroll1 = event.target.offsetHeight + Math.round(event.target.scrollTop) - 1;
    const totalScroll2 = event.target.offsetHeight + Math.round(event.target.scrollTop);
    const totalScroll3 = event.target.offsetHeight + Math.round(event.target.scrollTop) + 1;
    const scrollHeight = event.target.scrollHeight;
    if (
      (totalScroll1 === scrollHeight || totalScroll2 === scrollHeight || totalScroll3 === scrollHeight) &&
      !this.isLoad &&
      (this.totalList >= this.limit || (this.list.length == 0 && this.totalAgent >= this.limit))
    ) {
      setTimeout(() => {
        this.limit += 15;
        this.isLoad = true;
        this.loadData();
      }, 500);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/chat_internal.component.ts